import type { StateRevisions, StateStamp } from '@oysterjs/smartfill-contracts';

type SnapshotField = Exclude<keyof StateRevisions, 'epoch'>;

/** Producer order, unlike receipt order, survives a slow bootstrap read. */
export class SnapshotOrder {
  private epoch: string | null = null;
  private readonly retiredEpochs = new Set<string>();
  private revisions = new Map<SnapshotField, number>();

  beginBootstrap(epoch: string): boolean {
    if (this.retiredEpochs.has(epoch)) return false;
    if (this.epoch !== epoch) {
      if (this.epoch) this.retiredEpochs.add(this.epoch);
      this.epoch = epoch;
      this.revisions = new Map();
    }
    return true;
  }

  accept(field: SnapshotField, stamp?: StateStamp): boolean {
    if (!stamp) return false;
    if (this.epoch === null) this.epoch = stamp.epoch;
    if (stamp.epoch !== this.epoch || stamp.revision <= (this.revisions.get(field) ?? -1))
      return false;
    this.revisions.set(field, stamp.revision);
    return true;
  }
}
